<template>
  <canvas style="min-height: 350px;" ref="graph"></canvas>
</template>

<script>
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

/* eslint-disable security/detect-object-injection */
export default {
  name: 'assessmentHistoryChart',
  props: {
    dataset: {
      type: Object,
      required: true
    },
    scaleDefinition: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      key: 0,
      chartRef: null
    };
  },
  mounted () {
    if (this.dataset && this.scaleDefinition) {
      this.renderChart(this.dataset, this.scaleDefinition);
    }
  },
  methods: {
    renderChart (dataset, scaleDefinition) {
      if (!dataset) {
        if (this.chartRef) {
          this.chartRef.destroy();
        }
        return;
      }
      Chart.defaults.global.defaultFontSize = 10;
      Chart.defaults.global.defaultFontFamily = 'Lato,Roboto,Noto Sans,-apple-system,BlinkMacSystemFont,sans-serif';

      if (this.chartRef && this.chartRef.data && this.chartRef.data.datasets && this.chartRef.data.datasets.length > 0 && this.chartRef.data.datasets[0].name === dataset.name) {
        return;
      }
      this.key++;

      const chartConfig = {
        type: 'line',
        options: {
          responsive: true,
          maintainAspectRatio: false,
          borderDash: 0,
          spanGaps: true,
          tooltips: { enabled: false },
          layout: {
            padding: {
              left: 10,
              right: 30,
              top: 30,
              bottom: 0
            }
          },
          scales: {
            xAxes: [
              {
                type: 'time',
                time: {unit: 'day'},
                ticks: {
                  source: 'auto'
                },
                scaleLabel: {
                  display: true,
                  labelString: this.$t('products.assessment_history_chart.chart.label.xAxis')
                },
                gridLines: {
                  display: false
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 2,
                  min: scaleDefinition.min,
                  max: scaleDefinition.max,
                  stepSize: scaleDefinition.stepSize || 1
                },
                gridLines: {
                  display: true,
                  // color: [ 'black', 'black', 'red', 'red', 'red', 'orange', 'orange', 'green', 'green' ],
                  drawBorder: false
                }
              }
            ]
          },
          legend: {
            display: false
          },
          plugins: {
            datalabels: {
              formatter: (value) => {
                return value.y;
              },
              backgroundColor () {
                return 'white';
              },
              borderColor (context) {
                return context.dataset.borderColor;
              },
              borderWidth () {
                return 1;
              },
              font (context) {
                return context.selected ? {
                  weight: 'bold',
                  size: 18
                } : {
                  weight: 'normal',
                  size: 12
                };
              },
              padding (context) {
                const index = context.dataIndex;
                const value = context.dataset.data[index].y;
                return value < 10 ? {
                  top: 5,
                  bottom: 5,
                  left: 8,
                  right: 8
                } : 5;
              },
              borderRadius: 50,
              offset: 8,
              textAlign: 'center'
            }
          }
        },
        data: {
          datasets: [dataset]
        }
      };

      if (this.chartRef) {
        this.chartRef.destroy();
      }

      const chart = new Chart(this.$refs.graph, {
        type: chartConfig.type,
        data: chartConfig.data,
        options: chartConfig.options,
        plugins: [ChartDataLabels]
      });
      this.chartRef = chart;
    }
  }
};
</script>
